import React from 'react';
import 'dotenv';
import TagManager from 'react-gtm-module';
import { hot } from 'react-hot-loader/root';
import { Switch, Router } from 'react-router-dom';
import Global from '../utilities/styledComponents/Global';
import routes from '../../routes';
import ErrorBoundary from '../ErrorBoundary';
import { customHistory } from '../../services/hooks/UseHistoryPush';

const tagManagerCampanhasArgs = {
    gtmId: process.env.REACT_APP_GTM_CAM_TAG_ID,
    dataLayerName: 'Campanhas',
};

const tagManagerSitesArgs = {
    gtmId: process.env.REACT_APP_GTM_SITES_TAG_ID,
    dataLayerName: 'Sites',
};

const App = () => {
	TagManager.initialize(tagManagerCampanhasArgs);
	TagManager.initialize(tagManagerSitesArgs);

	return (
		<>
			<Global />
			<Router history={customHistory}>
				<ErrorBoundary>
					<Switch>
						{routes}
					</Switch>
				</ErrorBoundary>
			</Router>
		</>
	);
};

export default hot(App);
